// src/pages/dashboard/CustomerEmailListingPage.jsx
import React, { useEffect } from 'react'; // No need for useState, useCallback etc. here now
import PageHeading from '../../../components/PageHeading';
import Breadcrumb from '../../dashboard/pages/components/BreadCrumb';
import CustomerEmailLogs from './components/CustomerEmailLogs';
const CustomerEmailListingPage = () => {
  const breadcrumbItems = [
    { label: 'Dashboard', url: '/dashboard' },
    { label: 'Email Logs', url: '/dashboard/email-logs', current: true }
  ];

  useEffect(() => {
    document.title = 'CPA - Email Logs';
  }, []);

  return (
    <div className="p-4 sm:p-6 lg:p-8">
      <Breadcrumb items={breadcrumbItems} />
      <PageHeading value="Email Logs" />
      <CustomerEmailLogs customerPage={false} />
    </div>
  );
};

export default CustomerEmailListingPage;